import React, { useContext, useEffect, useState } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import LabeledInput from '../common/LabeledInput.jsx';
import { s } from '../Style.jsx';
import functions from '../utils/functions.js';
import StyledInput from '../common/StyledInput.jsx';
import Quantity from '../common/Quantity.jsx';

const Item = ({ items, item, vendorId, vendors, selectedItem, setSelectedItem }) => {

    const { cart, setCart, user } = useContext(PersonContext);
    const [combosOpen, setCombosOpen] = useState(false);
    const [optionsOpen, setOptionsOpen] = useState(false);
    const [choosingTag, setChoosingTag] = useState(null);

    const [choices, setChoices] = useState({
        quantity: 1,
        options: [],
        combo: {
            index: null,
            items: [],
        },
        notes: "",
    });
    useEffect(() => {
        setChoices({
            quantity: 1,
            options: [],
            combo: {
                index: null,
                items: item.combos.map(() => ""),
            },
            notes: "",
        });
    }, [item]);

    const [safeToAdd, setSafeToAdd] = useState(true);
    useEffect(() => {
        if (cart.vendorId && cart.vendorId != vendorId && !(vendors || []).find(v => v.id === cart.vendorId)) {
            setSafeToAdd(false);
        } else {
            setSafeToAdd(true);
        }
    }, [cart.vendorId, vendors]);

    const handleAddToCart = () => {
        if (!user) {
            window.location.href = "/login";
            return;
        }

        let newItem = {
            id: selectedItem.id,
            ...choices
        }

        setCart({
            ...cart,
            vendorId,
            items: safeToAdd
                ? [...(cart?.items || []), newItem]
                : [newItem]
        });
        setSelectedItem(null);
    };

    const instructions = option => {

        const { min, max } = option;

        if (min === 0 && max > 0) return "Choose up to " + max;
        if (min === 1 && max === 1) return "Choose 1";
        if (max > 1) return "Choose beteen " + min + " and " + max;

    }

    const getChoicesValue = () => {
        let subtotal = item.price;
        choices.options.forEach(option => {
            let item = items.find(item => item.id === option);
            subtotal += item.price;
        })
        if (choices.combo)
            subtotal += item.combos[choices.combo.index]?.price || 0;
        subtotal = subtotal * choices.quantity;
        return subtotal;
    }

    //order combos and options by price
    item.combos = item.combos?.sort((a, b) => a.price - b.price);
    let filteredItems = item.options?.map(option => {
        let sortedItems = (items || []).filter(item => item.tags?.includes(option?.tag));
        //sort
        sortedItems = sortedItems.sort((a, b) => a.price - b.price);
        return sortedItems;
    });


    if (!selectedItem) {

        if (item.images?.length)

            return <div onClick={() => setSelectedItem(item)} style={{ ...s.listItem, textAlign: "right", borderRadius: 8, padding: 10, marginBottom: 20, backgroundColor: "#fff", border: "1px solid #ccc" }}>
                <div style={s.rowTop}>
                    <div style={{ ...s.rowTop, flex: 1, maxWidth: item.images?.length ? 70 : "100%" }}>
                        <img src={item.images[0]} style={{ width: 70, height: 70, borderRadius: 8, border: "1px solid #000" }} />
                    </div>
                    <div style={{ flex: 1, textAlign: "left" }}>
                        <div style={{ ...s.rowTop }}>
                            <span>{item.name}</span>
                            <span style={{ marginBottom: 6, fontSize: 18, fontWeight: "bold", display: "block" }}>${functions.formatMoney(item.price)}</span>
                        </div>
                        {item.description && <span style={{ fontSize: 12, marginTop: 10, display: "block" }}>{item.description}</span>}
                    </div>
                </div>
            </div>;

        return <div onClick={() => setSelectedItem(item)} style={{ ...s.listItem, textAlign: "right", borderRadius: 8, padding: 10, marginBottom: 20, backgroundColor: "#fff", border: "1px solid #ccc" }}>
            <div style={s.row}>
                <span>{item.name}</span>
                <span style={{ fontSize: 18, fontWeight: "bold", display: "block" }}>${functions.formatMoney(item.price)}</span>
            </div>
            {item.description && <span style={{ fontSize: 12, marginTop: 10, display: "block" }}>{item.description}</span>}
        </div>;

    }



















    return <>
        <div style={s.row}>
            <h2 style={{ marginBottom: 10 }}><s.BackArrow does={() => setSelectedItem(null)} /> {item?.name}</h2>
            <span style={{ marginBottom: 10, fontSize: 18, fontWeight: "bold", display: "block" }}>${functions.formatMoney(item.price)}</span>
        </div>
        <div style={{ ...s.row, marginBottom: 10 }}>
            <div>
                <span style={{ display: "block", marginBottom: 10, fontSize: 14 }}>{item.description}</span>
                <div>
                    <Quantity value={choices.quantity} onChange={value => setChoices({ ...choices, quantity: value })} />
                </div>
            </div>
            {(item.images || []).slice(0, 5).map((image, i) => <img key={i} src={image} style={{ height: 80, objectFit: "cover", borderRadius: 8, border: "1px solid #000" }} />)}
        </div>

        {!!item.combos?.length && <div style={{ ...s.row, borderBottom: "1px solid #ccc", marginBottom: 10 }}>
            <h2 style={{ marginBottom: 10 }}>Make it a Combo</h2>
        </div>}

        {item.combos?.map((combo, i) => <div key={i} style={{ margin: "10px 0" }}>
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end", marginBottom: 10, justifyContent: "flex-end" }}>
                <span style={{ flex: 1, fontWeight: "bold", fontSize: 18 }}>{combo.name}</span>
                <span style={{ fontWeight: "bold", display: "block", fontSize: 14 }}>${functions.formatMoney(combo.price)}</span>
                <input type="checkbox" checked={choices?.combo?.index === i}
                    onChange={e => {
                        if (e.target.checked) {
                            //remove other combos and add this one
                            let newItems = item.combos.map(() => "");
                            //for each item in the combo, if there is only one item in items with that tag, set it by default
                            combo.items.forEach((item, j) => {
                                let itemsWithTag = items.filter(i => i.tags?.includes(item.tag));
                                if (itemsWithTag.length === 1) {
                                    newItems[j] = itemsWithTag[0].id;
                                }
                            }
                            );

                            setChoices({ ...choices, combo: { index: i, items: newItems } });
                        }
                        else {
                            //remove this combo
                            setChoices({ ...choices, combo: { index: null, items: item.combos.map(() => "") } });
                        }
                    }
                    } />
            </div>

            {!choosingTag && choices?.combo?.index === i && <div style={s.box}>
                {combo.items.map((item, j) => <div key={j} style={s.cell(j)}>
                    <span style={{ flex: 1, fontSize: 14 }}>{items.find(i => i.id === choices?.combo.items[j])?.name || item.name}</span>
                    <button onClick={() => {
                        setChoosingTag({ tag: item.tag, index: j });
                    }} style={{ ...s.button, marginBottom: 0 }}>{choices.combo.items[j] ? <i className="fas fa-check"></i> : "Choose"}</button>
                </div>)}
            </div>}

            {choosingTag && choices?.combo?.index === i && <>
                <span style={{ marginBottom: 10, display: "block", textAlign: "right", fontWeight: "bold" }}><s.BackArrow does={() => setChoosingTag(null)} />Choose 1</span>
                <div style={s.box}>
                    {items.filter(item => item.tags?.includes(choosingTag.tag)).map((item, j) =>
                        <div key={j} style={s.cell(j)} onClick={() => {
                            setChoices({ ...choices, combo: { ...choices.combo, items: (choices.combo.items).map((id, index) => index === choosingTag.index ? item.id : id || "") } });
                            setChoosingTag(null);
                        }
                        }><span style={{ flex: 1, fontSize: 14 }}>{item.name}</span></div>)}
                </div>
            </>}


        </div >)}

        {!!item.options?.length && <div style={{ ...s.row, borderBottom: "1px solid #ccc", marginBottom: 10 }}>
            <h2 style={{ marginBottom: 10 }}>Options</h2>
        </div>}

        {item.options?.map((option, i) => <div key={i} style={{ margin: "10px 0" }}>
            <div onClick={() => setOptionsOpen(!optionsOpen)} style={{ display: "flex", gap: 10, alignItems: "flex-end", marginBottom: 10 }}>
                <s.H2 style={{ fontSize: 14 }}>{option.name}</s.H2>
                <span style={{ display: "block", marginBottom: 10, fontSize: 14 }}>{instructions(option)}</span>
            </div>
            <div style={s.box}>
                {filteredItems[i]?.map((item, j) => <div key={j} style={s.cell(j)}>
                    <span style={{ flex: 1, fontSize: 14 }}>{item.name}</span>
                    <span style={{ fontSize: 14, fontWeight: "bold", display: "block" }}>${functions.formatMoney(item.price)}</span>
                    <input type="checkbox" checked={choices?.options?.includes(item.id)}
                        onChange={e => {
                            //prevent if min or max would be exceeded
                            let existingChoices = choices.options.filter(id => {
                                let item = items.find(item => item.id === id);
                                return item?.tags?.includes(option.tag);
                            });
                            if (option.max === 1 && option.min === 1) {
                                //remove other choices with this options tag, and add this one
                                setChoices({
                                    ...choices, options: [...choices.options.filter(id => {
                                        let item = items.find(item => item.id === id);
                                        return !item?.tags?.includes(option.tag);
                                    }
                                    ), item.id]
                                });
                            } else {
                                if (e.target.checked && existingChoices.length >= option.max) return;
                                if (!e.target.checked && existingChoices.length <= option.min) return;
                                setChoices({ ...choices, options: e.target.checked ? [...choices.options, item.id] : choices.options.filter(id => id !== item.id) });
                            }
                        }} />
                </div>)}
            </div>
        </div>)}

        <StyledInput style={{ marginTop: 10 }} placeholder="Special Instructions" type="textarea" value={choices.notes} onChange={e => setChoices({ ...choices, notes: e })} />

        {!safeToAdd && <>
            <span style={{ marginBottom: 10, marginTop: 10, display: "block" }}>You have items from a different vendor in your cart.</span>
            <button style={{ ...s.bigButton, margin: 0, backgroundColor: "#000", color: "#fff", cursor: "pointer" }} onClick={() => {
                setCart({ items: [], vendorId: "" });
            }}>Clear Cart</button>
        </>}

        {safeToAdd && <>
            <div style={{ display: "flex", gap: 10, padding: 10, alignItems: "center", marginBottom: 1, justifyContent: "space-between", border: "1px solid #ccc", borderRadius: 8 }}>
                <span style={{ display: "block", fontSize: 18, fontWeight: "bold" }}>${functions.formatMoney(getChoicesValue())}</span>
                {(() => {
                    let minMet = true;
                    let maxExceeded = false;
                    item.options?.forEach(option => {
                        let existingChoices = choices.options.filter(id => {
                            let item = items.find(item => item.id === id);
                            return item?.tags?.includes(option.tag);
                        });
                        if (existingChoices.length < option.min) minMet = false;
                        if (existingChoices.length > option.max) maxExceeded = true;
                    });
                    return <button style={{ ...s.bigButton, margin: 0, backgroundColor: minMet && !maxExceeded ? "#000" : "#ccc", color: minMet && !maxExceeded ? "#fff" : "#000", cursor: minMet && !maxExceeded ? "pointer" : "not-allowed" }} disabled={!minMet || maxExceeded} onClick={handleAddToCart}>Add to Cart</button>;
                }
                )()}
            </div>
        </>}
    </>;

}
export default Item;